<p-dialog
  [modal]="true"
  [closable]="false"
  [header]="data()?.title"
  [(visible)]="visible"
  (onHide)="onCancel()">
  <div class="dialog-content">
    @if (data()?.description) {
      <p [innerHTML]="data()?.description"></p>
    }

    @if (data()?.childTemplate) {
      <ng-container>
        <ng-container *ngTemplateOutlet="data()?.childTemplate; context: data()?.childContext"></ng-container>
      </ng-container>
    }
  </div>

  <ng-template #footer>
    <button
      (click)="onCancel()"
      class="swd-button xs secondary">
      {{ data()?.cancelLabel }}
    </button>
    <button
      (click)="onConfirm()"
      class="swd-button xs primary">
      {{ data()?.confirmLabel }}
    </button>
  </ng-template>
</p-dialog>
